import { Config } from "../../../api/config";
export var WorkPurchaseInvoiceKeys = {
    Paging: "workPurchaseInvoicePaging",
    Create: 'workPurchaseInvoiceCreate',
    Update: 'workPurchaseInvoiceUpdate',
    Upload: 'uploadPIAttachment',
    Get: 'GetWPI',
    DeleteAttachment: 'DeletePIAttachment',
    AttachmentCreate: 'AttachmentCreate',
    WorkPurchaseInvoiceDetails: 'workPurchaseInvoiceDetails',
    JobCardNumberList: 'getJobCardNumberList',
    WorkPurchaseInvoiceType: 'WorkPurchaseInvoice',
    WorkPurchaseOrderList: 'getWorkPurchaseOrderList',
    WorkPurchaseOrderDetails: 'getWorkPurchaseOrderDetails',
    OrganizationAddressList: 'getOrganizationAddressList',
    OrganizationAddressListDynamicKey: 'OrganizationAddressListDynamicKey',
    Cancel: 'cancelWorkPurchaseInvoice',
    CancellationReasonWPI: 'getCancellationReasonWPI',
    SupplierListWPO: 'supplierListWPO',
    WPISystemName: 'PurchaseOrder',
    PaymentTerms: "PaymentTerms",
    PaymentMethods: "PaymentMethods",
    JCNoByOrganization: "JCNoByOrganization",
    LabourListBySupplier: "LabourListBySupplier",
    AttachmentSystemName: 'PurchaseOrderAttachment'
};
export var viewTypeOptions = ["My work purchase invoice", "All work purchase invoice"];
export var WorkPurchaseInvoiceStatusEnum = /*#__PURE__*/ function (WorkPurchaseInvoiceStatusEnum) {
    WorkPurchaseInvoiceStatusEnum["Draft"] = "Draft";
    WorkPurchaseInvoiceStatusEnum["PendingApproval"] = "PendingApproval";
    WorkPurchaseInvoiceStatusEnum["Rejected"] = "Rejected";
    WorkPurchaseInvoiceStatusEnum["Cancelled"] = "Cancelled";
    return WorkPurchaseInvoiceStatusEnum;
}({});
export var WPIApiKeys = [WorkPurchaseInvoiceKeys.Paging, WorkPurchaseInvoiceKeys.WorkPurchaseInvoiceDetails, WorkPurchaseInvoiceKeys.Create];
export var WorkPurchaseInvoiceMandatoryFeilds = {
    'JobCard': 'JobCard',
    'ChildId': 'Service',
    'RequestedQuantity': 'RequestedQuantity'
};
export var WorkPurchaseInvoicePagingAPIUrl = "".concat(Config.baseURL, "WorkPurchaseOrder/Paging");
export var SupplierListWPOUrl = "".concat(Config.baseURL, "Supplier/SupplierListWPO");
export var PaymentMethodsListUrl = "".concat(Config.baseURL, "PaymentTermMethod/List");
export var PaymentTermsListUrl = "".concat(Config.baseURL, "PaymentTerm/List");
export var GetWorkPurchaseOrderListAPIUrl = "".concat(Config.baseURL, "PurchaseOrder/CompletedWorkPurchaseOrder");
export var GetWorkPurchaseOrderDetailsAPIUrl = "".concat(Config.baseURL, "WorkPurchaseOrder/GetWorkPurchaseOrder");
export var OrganizationAddressListAPIUrl = "".concat(Config.baseURL, "OrganizationAddress/OrganizationAddressList");
export var CancelationReasonWPIListAPIUrl = "".concat(Config.baseURL, "CancellationReason/GetBySystemName");
export var CancelWorkPurchaseInvoiceAPIUrl = "".concat(Config.baseURL, "WorkPurchaseOrder/UpdateStatusPO");
export var CreateWorkPurchaseInvoiceAPIUrl = "".concat(Config.baseURL, "WorkPurchaseOrder/CreateWorkPurchaseInvoice");
export var JCNoByOrganizationAPIUrl = "".concat(Config.baseURL, "JobCard/ByJobCardNoWPO");
export var LabourListWPOAPIUrl = "".concat(Config.baseURL, "Labour/LabourListWPO");
export var PIAttachmentCreateAPIUrl = "".concat(Config.baseURL, "PurchaseOrderAttachment/Create");
export var PIAttachmentDeleteAPIUrl = "".concat(Config.baseURL, "PurchaseOrderAttachment/Delete");
